import { TabBar, TabLink } from 'features/navigation'
import { routePaths } from '../../../../routes'

export const SingleClientTabs = () => (
  <TabBar className="mt-10">
    <TabLink path="" label="rideHistory" />
    <TabLink path={routePaths.transactionsHistory} label="transactions" />
  </TabBar>
)
